import { reactive, toRefs } from 'vue'
import { getPlanInfo } from '@/api/convert.model'
import { getLandPageUrl } from '@/api/landpage.model'
import { queryImageDetailByIds } from '@/api/tencentada.model'
import { isEmpty } from '@/common/js/utils'

export function usePlanActions(proxy, datetimeState) {
  const state = reactive({
    showMultiImageModal: false,
    multiImagesList: [],
    showDetailsDrawer: false,
    draInfo: {}
  })

  const getPlanInfoById = (planId) => {
    return new Promise((resolve, reject) => {
      if (!planId) reject(new Error('planId required'))
      getPlanInfo({ planId }).then((data) => {
        if (typeof data !== 'symbol') {
          const { adId, advertiserId, creativeIds } = data || {}
          resolve({
            adId: adId || '',
            advertiserId: advertiserId || '',
            creativeIds: creativeIds || []
          })
        }
      }).catch(reject)
    })
  }

  const handleDetail = async (row) => {
    try {
      const info = await getPlanInfoById(row.planId)
      state.draInfo = Object.assign({}, row, info, { dateTime: datetimeState.value })
      state.showDetailsDrawer = true
    } catch (e) {
      console.error('e output: ', e)
      proxy.$Message.error('获取计划详情失败')
    }
  }

  const handleShow = (param) => {
    const { key, row } = param
    const params = { planId: row.planId }
    let src
    if (key === 'pageId') {
      getLandPageUrl(params).then((data) => {
        src = data.landingPageUrl
        if (isEmpty(src)) {
          proxy.$Message.info('落地页不存在！', 1500)
          return
        }
        if (src.indexOf('?') > 0) {
          src += '&_t=' + Math.random()
        } else {
          src += '?_t=' + Math.random()
        }
        window.open(src)
      })
    } else if (key === 'imageName') {
      src = row.imageAddr
      const videoUrl = row.videoUrl
      const video = !isEmpty(videoUrl)
      proxy.$Gallery.open({ src, video, videoUrl })
    }
  }

  const showMultiImage = (row) => {
    const ids = row.imageDetailIds ? row.imageDetailIds.split(',') : []
    queryImageDetailByIds({ ids }).then((data) => {
      if (data?.length) {
        state.multiImagesList = data.map((i) => {
          return {
            ...i,
            url: `https://ptom-resource-cos.caohua.com/ptom/${i.addr}`
          }
        })
      }
      state.showMultiImageModal = true
    })
  }

  const batchActions = (type) => {
    const planDataTable = proxy.$refs.planDataTableRef
    if (!planDataTable) return

    switch (type) {
      case -1:
      case 0:
      case 1:
      case 3:
        planDataTable.changeBetch(type)
        break
      case 4:
        planDataTable.showPlanAutoAcquisitionModal(type)
        break
      case 5:
        planDataTable.showSyncMaterialsBinding(type)
        break
      case 6:
        planDataTable.showProjectBatchBudgetModal()
        break
      case 7:
        planDataTable.showPlanBatchBudgetModal()
        break
      case 8:
        planDataTable.showPlanBatchBidModal()
        break
      case 9:
        planDataTable.showPlanBatchDateTimeScheduleModal()
        break
      default:
        break
    }
  }

  return {
    ...toRefs(state),
    handleDetail,
    handleShow,
    showMultiImage,
    batchActions
  }
}

/**
 * @description: 广点通创意优投
 * @return {*}
 */
export const usePremiumCreativeConfig = () => {
  const state = reactive({
    premiumCreativeConfigModalVisible: false,
    currentPremiumRow: null
  })

  const showPremiumCreativeConfigModal = (row) => {
    state.currentPremiumRow = row
    state.premiumCreativeConfigModalVisible = true
  }

  return {
    ...toRefs(state),
    showPremiumCreativeConfigModal
  }
}
